/*=============================================== FlexboxPage ===============================================*/

import { Flexbox } from "tsx-library-julseb"

import { ComponentsLayout, GridItem } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, paddingObject } from "data"

const FlexboxPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Flexbox
                    flexDirection="column-reverse"
                    gap="l"
                    alignItems="flex-end"
                    justifyContent="flex-end"
                >
                    <GridItem />
                    <GridItem>Longer item</GridItem>
                    <GridItem />
                    <GridItem>Even longer item</GridItem>
                </Flexbox>
            ),
            code: '<Flexbox\n    flexDirection="column-reverse"\n    gap="l"\n    alignItems="flex-end"\n    justifyContent="flex-end"\n>\n    \n</Flexbox>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "flexDirection",
            type: "string",
            possible: ["row", "row-reverse", "column", "column-reverse"],
        },
        {
            subtitle: "flexWrap",
            type: "string",
            possible: ["nowrap", "wrap", "wrap-reverse"],
        },
        {
            subtitle: "alignContent",
            type: "string",
            possible: commonProps.flexAlignContent,
        },
        {
            subtitle: "justifyContent",
            type: "string",
            possible: commonProps.flexJustifyContent,
        },
        {
            subtitle: "alignItems",
            type: "string",
            possible: commonProps.flexAlignItems,
        },
        {
            subtitle: "justifyItems",
            type: "string",
            possible: commonProps.flexJustifyItems,
        },
        {
            subtitle: "gap",
            type: "string or number",
            possible: commonProps.spacers,
        },
        {
            subtitle: "rowGap",
            type: "string or number",
            possible: commonProps.spacers,
        },
        {
            subtitle: "columnGap",
            type: "string or number",
            possible: commonProps.spacers,
        },
        {
            subtitle: "inline",
            intro: (
                <>
                    Sets the <code>display</code> to <code>inline-flex</code>
                </>
            ),
            type: "boolean",
        },
        ...paddingObject(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default FlexboxPage
